export const ACTIVE_PROJECTS_SCHIP_SUBMODULE_ID = 35
export const PROJECTS_LITE_NO_PRODUCTS_SUBMODULE_ID = 36
export const ACTIVE_PROJECTS_NO_PRODUCTS_SUBMODULE_ID = 38
export const ACTIVE_PROJECTS_NO_PRODUCTS_GRONDBANK_SUBMODULE_ID = 43
export const ACTIVE_PROJECTS_NO_VERVOERDER_GRONDBANK_SUBMODULE_ID = 44
